(() => {
  'use strict';
  const instances = new WeakMap();
  const BEAUTYVES = new Set('siero-niacinamide-beautyves,siero-vitamina-c-beautyves,siero-collagene-beautyves,siero-lifting-occhi,siero-acido-ialuronico-beautyves,crema-viso-niacinamide,crema-viso-vitamina-c-beautyves,acido-salicilico-esfoliante,crema-viso-collagene-beautyves,crema-viso-acido-ialuronico-beautyves,mascara-volumizzante-incurvante,contorno-occhi-acido-ialuronico-anti-rughe,contorno-occhi-caffeina-anti-borse,volumizzante-labbra,primer-matte-affina-pori,primer-effetto-glow-con-spf30,eyeliner-ultra-precision,04-correttore-massima-coprenza-copia,pochette-beautyves,mystery-box-beautyves-premium'.split(','));
  function init(phone) {
  if (instances.has(phone)) return;
  const controller = new AbortController();
  let disposed = false;
  const timers = new Set();
  const later = (callback, delay) => {
    const timer = setTimeout(() => { timers.delete(timer); if (!disposed) callback(); }, delay);
    timers.add(timer);
    return timer;
  };
  const onWindow = (event, callback, options = {}) => window.addEventListener(event, callback, { ...options, signal: controller.signal });
  const listen = (node, event, callback, options = {}) => node?.addEventListener(event, callback, { ...options, signal: controller.signal });
  const observers = [];
  const observe = (observer, target, options) => { observer.observe(target, options); observers.push(observer); };
  const dataNode = phone.querySelector('#bp-dati') || (phone.nextElementSibling?.id === 'bp-dati' ? phone.nextElementSibling : null);
  if (!dataNode) throw new Error('BP PDP: dati pagina mancanti');
  const D = JSON.parse(dataNode.textContent);
  const routeRoot = window.Shopify?.routes?.root || '/';
  const cartURL = (path) => routeRoot.replace(/\/$/, '') + '/cart/' + path;
  const single = D.prodotto.tipo === 'singolo';
  // Zoom del solo testo: la scena sticky diventa una lista leggibile a >=150%.
  const root = document.documentElement;
  const textZoomThreshold = phone.dataset.bpContesto === 'tema' ? 15 : 24;
  const updateTextZoom = () => root.classList.toggle('bp-text-zoom', parseFloat(getComputedStyle(root).fontSize) >= textZoomThreshold);
  updateTextZoom();
  // La soglia dipende dal font, non dall'altezza del documento: osservare
  // la geometria della radice crea un loop WebKit quando cambia il reflow.
  observe(new MutationObserver(updateTextZoom), root, { attributes: true, attributeFilter: ['style'] });
  onWindow('resize', updateTextZoom);
  const C = D._comuni;
  const SHOP = C.negozio;
  const SHIP = Number(C.spedizione.costo);
  const FREE = Number(C.spedizione.soglia_gratis);
  const MAXQ = Number(D.prodotto.quantita_max);
  const u = (f, w) => {
    if (!f) return '';
    if (/^(?:https?:)?\/\//.test(f)) return f + (f.includes('?') ? '&' : '?') + 'width=' + w;
    const variant = D.varianti.find((item) => item.immagine === f && item._web);
    if (variant) {
      const widths = Object.keys(variant._web).map(Number).filter(Number.isFinite).sort((a, b) => a - b);
      const selected = widths.find((width) => width >= w) || widths[widths.length - 1];
      if (selected) return variant._web[selected];
    }
    return f;
  };
  const srcset = (f, requestedWidths) => {
    const variant = D.varianti.find((item) => item.immagine === f && item._web);
    if (variant && !/^(?:https?:)?\/\//.test(f)) {
      const seen = new Set();
      return Object.keys(variant._web).map(Number).filter((width) => Number.isInteger(width) && width > 0)
        .sort((a, b) => a - b).filter((width) => {
          const file = variant._web[width];
          if (!file || seen.has(file)) return false;
          seen.add(file);
          return true;
        }).map((width) => variant._web[width] + ' ' + width + 'w').join(', ');
    }
    return requestedWidths.map((width) => u(f, width) + ' ' + width + 'w').join(', ');
  };
  const esc = (value) => String(value).replace(/[&<>"']/g, (ch) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[ch]);
  const safeHex = (value) => /^#[0-9a-fA-F]{6}$/.test(value) ? value : '#cccccc';
  const S = D.varianti.map((s) => {
    const maxQ = Number.isInteger(Number(s.quantita_max)) ? Math.max(0, Math.min(MAXQ, Number(s.quantita_max))) : MAXQ;
    return {
    c: s.codice || '', vid: s.id_variante, hex: s.hex, tone: s.tono || '',
    mood: s.descrizione || '', img: s.immagine, w: s.simulazione?.griglia ?? 0,
    row: s.simulazione?.riga ?? 0,
    rv: s.recensioni ? [s.recensioni.media, s.recensioni.numero] : null,
    hot: s.etichetta === 'Più recensito', bg: !!s.immagine_schiarita,
    available: !!s.disponibile && maxQ > 0, price: Number(s.prezzo), maxQ
    };
  });
  const WORN = (D.simulazioni || []).map((g) => ({
    f: g.file, W: g.W, H: g.H, cols: g.colonne, rows: g.righe, cells: g.celle,
    nativeRatio: g.rapporto_celle === 'nativo'
  }));
  const G = (D.carrello.abbinamento?.varianti || []).filter((g) => g.disponibile !== false && g.id_variante).map((g) => ({
    c: g.codice, vid: g.id_variante, hex: g.hex, img: g.immagine,
    price: Number(g.prezzo ?? D.carrello.abbinamento.prezzo)
  }));
  const pairingControlLabel = D.carrello.abbinamento?.etichetta_controllo || '';
  const R = (D.recensioni?.testi || []).slice(0, 10).map((r) => ({
    c: r.codice, n: r.nome, t: r.testo, stars: r.stelle
  }));
  const COMPLETE = (D.carrello.completa?.schede || []).filter((item) => item.disponibile === true && item.id_variante).slice(0, 3);

  const panels = [];
  const $ = (s, r) => r ? r.querySelector(s) : phone.querySelector(s) || panels.map((p) => p.querySelector(s)).find(Boolean) || null;
  const $$ = (s, r) => r ? [...r.querySelectorAll(s)] : [...phone.querySelectorAll(s), ...panels.flatMap((p) => [...p.querySelectorAll(s)])];
  const eur = (n) => '€ ' + n.toFixed(2).replace('.', ',');
  const dec = (n) => n.toFixed(1).replace('.', ',');
  const recensionLabel = (n) => Number(n) === 1 ? 'recensione' : 'recensioni';
  const ease = (t) => 1 - Math.pow(1 - t, 3);
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const buzz = (ms) => { try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) { /* nessuna vibrazione */ } };
  const bead = (hex, extra) => '<span class="bead' + (extra ? ' ' + extra : '') + '" style="--c:' + safeHex(hex) + '"></span>';
  const darker = (hex, k) => {
    const n = parseInt(hex.slice(1), 16), f = (v) => Math.round(v * (1 - k));
    return '#' + [n >> 16 & 255, n >> 8 & 255, n & 255].map((v) => f(v).toString(16).padStart(2, '0')).join('');
  };

  const gal = $('#gal'), sheet = $('#sheet'), lb = $('#lb'), toastEl = $('#toast'), dock = $('#dock');
  for (const panel of [sheet, lb, toastEl]) {
    if (!panel) continue;
    panel.dataset.bpPanelOwner = D.prodotto.handle;
    panel.classList.add('bp-pannello');
    panels.push(panel);
    document.body.appendChild(panel);
  }
  const looxHost = phone.parentElement?.querySelector('[data-bp-loox-host]');
  const looxTarget = $('#recensioni');
  let looxPlaceholder = null;
  if (looxHost && looxTarget && !looxTarget.hidden) {
    looxPlaceholder = document.createComment('bp-loox-host');
    looxHost.parentNode.insertBefore(looxPlaceholder, looxHost);
    looxTarget.appendChild(looxHost);
  }
  if (pairingControlLabel && $('#glPills')) $('#glPills').setAttribute('aria-label', pairingControlLabel);
  let headerRaf = 0;
  if (phone.dataset.bpContesto === 'tema') {
    const setThemeHeaderHeight = () => {
      const header = document.querySelector('.bp-theme-header, page-header, .wt-header') || document.querySelector('header, [data-section-type="header"], .header-wrapper');
      if (header) {
        const position = Math.max(0, header.getBoundingClientRect().bottom);
        phone.style.setProperty('--bp-header-h', position + 'px');
        panels.forEach((panel) => panel.style.setProperty('--bp-header-h', position + 'px'));
      }
    };
    const scheduleHeaderHeight = () => {
      if (!headerRaf) headerRaf = requestAnimationFrame(() => { headerRaf = 0; if (!disposed) setThemeHeaderHeight(); });
    };
    setThemeHeaderHeight();
    const header = document.querySelector('.bp-theme-header, page-header, .wt-header') || document.querySelector('header, [data-section-type="header"], .header-wrapper');
    if (header) observe(new ResizeObserver(scheduleHeaderHeight), header);
    onWindow('resize', scheduleHeaderHeight);
    onWindow('scroll', scheduleHeaderHeight, { passive: true });
  }
  const st = { i: 0, q: 1, g: 0, lines: [], fresh: [], gIdx: 0, lbIdx: 0 };
  const showReviewCardStars = Number(D.recensioni?.numero ?? 0) >= 3;
  const v = phone.dataset.bpSelectedVariant || new URLSearchParams(location.search).get('variant');
  const vi = S.findIndex((s) => String(s.vid) === v);
  if (vi > -1) st.i = vi;

  // ---------------------------------------------------------------------------
  // COSTRUZIONE degli elementi ripetuti (8 colori ovunque)
  // ---------------------------------------------------------------------------
  if (!single) {
  const reviewText = (s) => s.rv ? '★ ' + dec(s.rv[0]) + ' · ' + s.rv[1] + ' ' + recensionLabel(s.rv[1]) :
    D.recensioni?.per_variante === false ? '' : 'Ancora senza recensioni';
  $('#beads').innerHTML = S.map((s, k) =>
    '<button class="bd" role="radio" aria-checked="false" tabindex="-1" data-i="' + k + '" aria-label="' + esc((s.hot ? 'Più recensito ' : '') + s.c + ' ' + s.tone + (s.available ? '' : ' esaurito')) + '">' +
    (s.hot ? '<span class="hot" aria-hidden="true">Più recensito</span> ' : '') + bead(s.hex) +
    '<b>' + esc(s.c) + '</b> <small>' + esc(s.tone) + '</small></button>').join('');
  $('#rail').innerHTML = S.map((s, k) =>
    '<button data-i="' + k + '" aria-pressed="false" aria-label="Colore ' + esc(s.c + ' ' + s.tone) + '">' + bead(s.hex) + '</button>').join('');
  $('#i8grid').innerHTML = S.map((s) => '<span>' + bead(s.hex) + esc(s.c) + '</span>').join('');
  $('#grid8').innerHTML = S.map((s, k) =>
    '<button class="card" data-bp="scheda-colore" data-i="' + k + '" aria-pressed="false" aria-label="Scegli ' + esc(s.c + ' ' + s.tone + (reviewText(s) ? ' ' + reviewText(s) : '')) + '">' +
    '<img alt="' + esc(D.prodotto.nome_alt + ' ' + s.c + ' – ' + s.tone) + '" width="400" height="400" loading="lazy" decoding="async"' + (s.bg ? ' class="bgfix"' : '') +
    ' src="' + esc(u(s.img, 400)) + '" srcset="' + esc(srcset(s.img, [300, 500])) + '" sizes="(max-width: 440px) 44vw, 200px">' +
    '<span class="cc">' + bead(s.hex) + '<b class="num">' + esc(s.c) + '</b></span> <span class="tn">' + esc(s.tone) + '</span> ' +
    '<span class="rv">' + reviewText(s) + '</span></button>').join('');
  const maxRv = Math.max(1, ...S.map((s) => (s.rv ? s.rv[1] : 0)));
  if ($('#rvTab')) $('#rvTab').innerHTML = S.map((s) =>
    '<li>' + bead(s.hex) + '<b class="num">' + esc(s.c) + '</b><span class="bar"><i style="width:' + (s.rv ? (s.rv[1] / maxRv) * 100 : 0) + '%"></i></span>' +
    '<em class="num">' + (s.rv ? '★ ' + dec(s.rv[0]) + ' (' + s.rv[1] + ')' : 'nuovo') + '</em></li>').join('');
  $('#rvCards').innerHTML = R.map((r) => {
    const s = S.find((x) => x.c === r.c);
    const attribution = s && r.c ? ' · colore ' + esc(r.c + ' ' + s.tone) : '';
    return '<figure class="lgs rc" data-bp="recensione"><blockquote>«' + esc(r.t) + '»</blockquote><figcaption>' + (s && r.c ? bead(s.hex) : '') + '<span><b>' + esc(r.n) + '</b>' + attribution + (showReviewCardStars && r.stars && !attribution ? ' · ★ ' + esc(r.stars) + '/5' : '') + '</span></figcaption></figure>';
  }).join('');
  $('#shMini').innerHTML = S.map((s, k) => s.available ?
    '<button data-i="' + k + '" aria-label="Aggiungi anche il ' + esc(s.c + ' ' + s.tone) + '">' + bead(s.hex) + '<span>' + esc(s.c) + '</span></button>' : '').join('');
  $('#shMini').style.gridTemplateColumns = 'repeat(' + Math.min(8, S.filter((s) => s.available).length) + ',1fr)';
  if ($('#glPills')) $('#glPills').innerHTML = G.map((g, k) =>
    '<button role="radio" data-k="' + k + '" aria-checked="' + (k === 0) + '" aria-label="' +
    esc(pairingControlLabel ? D.carrello.abbinamento.titolo : 'Gloss ' + g.c) +
    '" style="--c:' + safeHex(g.hex) + '"><i></i>' + esc(g.c) + '</button>').join('');
  const columns = S.length <= 4 ? S.length : S.length <= 6 ? 3 : 4;
  $('#beads').style.gridTemplateColumns = 'repeat(' + columns + ',1fr)';
  $('#i8grid').style.gridTemplateColumns = 'repeat(' + columns + ',1fr)';
  } else {
    const cards = (D.gamma.schede || []).filter((card) => card.disponibile !== false || card.corrente);
    $('#grid8').innerHTML = cards.map((card) => {
      const body = '<img src="' + esc(u(card.immagine, 500)) + '" width="400" height="400" loading="lazy" alt="' + esc(card.nome_breve) + '">' +
        '<span class="cc"><b>' + esc(card.nome_breve) + '</b></span><span class="tn num">' + eur(Number(card.prezzo)) + '</span>' +
        '<span class="rv">' + (card.recensioni ? esc(String(card.recensioni)) + ' ' + recensionLabel(card.recensioni) : 'Ancora senza recensioni') + '</span>' +
        (card.corrente ? '<span class="family-current">Questo</span>' : '');
      return card.corrente ? '<div class="card family-card current" data-bp="scheda-famiglia" aria-current="page">' + body + '</div>' :
        '<a class="card family-card" data-bp="scheda-famiglia" href="' + esc(SHOP + '/products/' + card.handle) + '">' + body + '</a>';
    }).join('');
    $('#rvCards').innerHTML = R.map((r) => '<figure class="lgs rc" data-bp="recensione"><blockquote>«' + esc(r.t) + '»</blockquote><figcaption><span><b>' + esc(r.n) + '</b>' + (showReviewCardStars && r.stars ? ' · ★ ' + esc(r.stars) + '/5' : '') + '</span></figcaption></figure>').join('');
    $('#shMini').innerHTML = COMPLETE.map((item, k) => '<button class="complete-item" type="button" data-k="' + k + '"><img src="' + esc(u(item.immagine, 160)) + '" width="50" height="50" alt=""><span>' + esc(item.nome_breve) + '</span><b class="num">+ ' + eur(Number(item.prezzo)) + '</b></button>').join('');
    $('#shUp').hidden = COMPLETE.length === 0;
    if ($('#glPills')) $('#glPills').innerHTML = G.map((g, k) =>
      '<button role="radio" data-k="' + k + '" aria-checked="' + (k === 0) + '" aria-label="' + esc(D.carrello.abbinamento.titolo + ' ' + g.c) + '" style="--c:' + safeHex(g.hex) + '"><i></i>' + esc(g.c) + '</button>').join('');
  }

  // ROI esplicite per media con incarnati in verticale; griglie storiche invariate.
  function cellRoi(g, row, col) {
    return g.cells ? g.cells[row][col] : [g.cols[col][0], g.rows[row][0], g.cols[col][1], g.rows[row][1]];
  }
  function cellCount(g, row) { return g.cells ? g.cells[row].length : g.cols.length; }
  // Ritaglio delle simulazioni: 5:4 storico, proporzione nativa solo con opt-in o ROI esplicite.
  function cropCell(box, g, row, col) {
    const [x0, y0, x1, y1] = cellRoi(g, row, col), cw = x1 - x0, ch = y1 - y0;
    // Nelle ROI esplicite il riquadro segue la proporzione del media: nessun lato della cella è tagliato.
    const nativeRatio = !!g.cells || g.nativeRatio;
    const A = nativeRatio ? cw / ch : 5 / 4;
    box.style.aspectRatio = nativeRatio ? cw + ' / ' + ch : '';
    const img = box.querySelector('img');
    if (g.cells && x0 === 0 && x1 === g.W) {
      // Cella larga quanto la sorgente: il box immagine resta nel viewport e
      // WebKit avvia il caricamento lazy; object-position ritaglia i pixel y0..y1.
      Object.assign(img.style, { width: '100%', height: '100%', left: '0px', top: '0px',
        objectFit: 'cover', objectPosition: 'center ' +
          (g.H === ch ? 50 : 100 * y0 / (g.H - ch)) + '%' });
      return;
    }
    const k = Math.max(1 / cw, 1 / (A * ch)); // scala in unità di larghezza del riquadro
    // WebKit può lasciare a zero l'altezza auto delle img lazy assolute native:
    // la percentuale esplicita equivale esattamente al rapporto della sorgente.
    img.style.height = g.nativeRatio ? (g.H * k * A * 100) + '%' : '';
    img.style.objectFit = '';
    img.style.objectPosition = '';
    img.style.width = (g.W * k * 100) + '%';
    img.style.left = ((-x0 * k + (1 - cw * k) / 2) * 100) + '%';
    img.style.top = ((-y0 * k * A + (1 - ch * k * A) / 2) * 100) + '%';
  }
  let syncPackPresentation = () => {};
  if (D.presentazione_packshot?.modalita === 'intero') {
    const variantsPresentation = D.presentazione_packshot.per_variante;
    let activePresentation = variantsPresentation?.[D.varianti[0].codice] || D.presentazione_packshot;
    const composition = D.presentazione_packshot.impaginazione === 'composizione';
    const wideShadow = D.presentazione_packshot.impaginazione === 'ombra-larga';
    const place = (frame, image, maxW, maxH, left, top) => {
      const [sourceW, sourceH] = activePresentation.dimensioni_sorgente;
      const [x0, y0, x1, y1] = activePresentation.inquadratura;
      const cropW = x1 - x0, cropH = y1 - y0;
      const scale = Math.min(maxW / cropW, maxH / cropH);
      const width = cropW * scale, height = cropH * scale;
      Object.assign(frame.style, { left: left(width) + 'px', top: top(height) + 'px', width: width + 'px', height: height + 'px' });
      Object.assign(image.style, { left: -x0 * scale + 'px', top: -y0 * scale + 'px', width: sourceW * scale + 'px', height: sourceH * scale + 'px' });
    };
    const art = $('.st-art'), storyFrame = $('.st-prod', art), storyImage = $('.js-pack', storyFrame);
    const storySign = $('.st-vis', art);
    const end = $('.end-art'), endFrame = $('.end-pack-crop', end), endImage = $('.js-pack', endFrame);
    const layout = () => {
      if (art.clientWidth && art.clientHeight) {
        const wideComposition = composition && art.clientWidth > 600;
        const themeDesktop = phone.dataset.bpContesto === 'tema' && matchMedia('(min-width:900px)').matches;
        const laneFraction = D.presentazione_packshot.corsia_storia ??
          (wideComposition ? .65 : composition ? .85 : wideShadow ? .7 : .47);
        const lane = art.clientWidth * laneFraction;
        // La madre tema limita il pack storia a 240px: l'opt-in conserva il compatto intero.
        if (D.presentazione_packshot.corsia_storia != null) storyFrame.style.maxWidth = themeDesktop ? '240px' : 'none';
        if (D.presentazione_packshot.segno_storia != null) {
          storySign.style.left = (D.presentazione_packshot.segno_storia * 100) + '%';
        } else if (composition) storySign.style.left = wideComposition ? '60%' : '68%';
        const storyMaxWidth = lane - (composition ? 8 : 16);
        place(storyFrame, storyImage, themeDesktop ? Math.min(240, storyMaxWidth) : storyMaxWidth, art.clientHeight - 20,
          (width) => (lane - width) / 2, (height) => (art.clientHeight - height) / 2);
      }
      if (end.clientWidth && end.clientHeight) {
        place(endFrame, endImage, Math.min(290, end.clientWidth - 20), Math.min(290, end.clientHeight - 10),
          (width) => (end.clientWidth - width) / 2, (height) => (end.clientHeight - height) / 2);
      }
    };
    layout();
    const sizeObserver = new ResizeObserver(layout);
    observe(sizeObserver, art);
    sizeObserver.observe(end);
    if (variantsPresentation) syncPackPresentation = (code) => {
      activePresentation = variantsPresentation[code];
      if (activePresentation.maschera) {
        phone.dataset.bpPackMask = 'silhouette';
        phone.style.setProperty('--bp-pack-mask', 'url("' + activePresentation.maschera + '")');
      } else {
        delete phone.dataset.bpPackMask;
        phone.style.removeProperty('--bp-pack-mask');
      }
      phone.dataset.bpPackImageKind = activePresentation.tipo;
      layout();
    };
  }
  $$('.story-lens img[data-focus-x]').forEach((img) => {
    const position = () => {
      const width = Number(img.dataset.sourceW) || img.naturalWidth;
      const height = Number(img.dataset.sourceH) || img.naturalHeight;
      const diameter = img.parentElement.clientWidth;
      if (!width || !height || !diameter) return;
      const scale = diameter * 2.35 / width;
      Object.assign(img.style, {
        width: width * scale + 'px', height: height * scale + 'px',
        left: diameter * .5 - Number(img.dataset.focusX) * scale + 'px',
        top: diameter * .458 - Number(img.dataset.focusY) * scale + 'px'
      });
    };
    listen(img, 'load', position);
    if (img.complete) position();
    observe(new ResizeObserver(position), img.parentElement);
  });

  // ---------------------------------------------------------------------------
  // CARRELLO dell'anteprima (in negozio è il carrello vero di Shopify)
  // ---------------------------------------------------------------------------
  const lipLine = (i) => ({ vid: S[i].vid, kind: 'l', title: D.carrello.riga_titolo, sub: single ? D.prodotto.nome_breve : D.carrello.riga_sotto.replace('{codice}', S[i].c).replace('{tono}', S[i].tone), img: u(S[i].img, 160), price: S[i].price, bg: S[i].bg });
  const glossLine = (k) => ({ vid: G[k].vid, kind: 'g', title: D.carrello.abbinamento.riga_titolo, sub: D.carrello.abbinamento.riga_sotto.replace('{codice}', G[k].c), img: u(G[k].img, 160), price: G[k].price });
  const completeLine = (k) => ({ vid: String(COMPLETE[k].id_variante), kind: 'c', title: COMPLETE[k].nome_breve, sub: COMPLETE[k].nome_breve, img: u(COMPLETE[k].immagine, 160), price: Number(COMPLETE[k].prezzo) });
  let busy = false;
  const setBusy = (value) => {
    busy = value;
    $$('.js-add, #shMini button, #glAdd, #shList button').forEach((button) => { button.disabled = value; });
    if (!value) render();
  };
  async function cartRequest(path, body) {
    const response = await fetch(routeRoot.replace(/\/$/, '') + (path === 'cart.js' ? '/cart.js' : '/cart/' + path), {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin', signal: controller.signal
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Impossibile aggiornare il carrello');
    return data;
  }
  function syncCart(cart) {
    st.cart = cart;
    st.lines = cart.items.map((item) => ({
      key: item.key, vid: String(item.variant_id), qty: item.quantity,
      title: item.product_title || item.title, sub: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
      img: item.image || item.featured_image?.url || '', price: item.final_price / 100,
      total: item.final_line_price / 100, handle: item.handle || '', bg: false
    }));
    updateCartCount();
    if (!sheet.hidden) renderSheet();
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
  }
  async function refreshCart() { const cart = await cartRequest('cart.js'); if (disposed) return; syncCart(cart); }
  function reportCartError(error) { if (!disposed && error?.name !== 'AbortError') toast(error?.message || 'Impossibile aggiornare il carrello', 3500); }
  async function addItems(items) {
    if (busy || !items.length) return false;
    setBusy(true);
    try {
      await cartRequest('add.js', { items: items.map((item) => ({ id: Number(item.vid), quantity: item.qty })) });
      if (disposed) return false;
      await refreshCart();
      if (disposed) return false;
      if (window.BPLaunchCart?.campaignActive()) {
        await window.BPLaunchCart.sync();
        if (ov === sheet) await openCampaignNative(document.activeElement);
      }
      st.fresh = items.map((item) => String(item.vid));
      return true;
    } catch (error) { reportCartError(error); return false; }
    finally { if (!disposed) setBusy(false); }
  }
  const cartQty = () => st.cart?.item_count || 0;
  const cartTot = () => st.lines.reduce((n, l) => n + l.total, 0);
  const generalTotal = () => st.lines.filter((line) => !BEAUTYVES.has(line.handle)).reduce((n, line) => n + line.total, 0);
  function updateCartCount() {
    const count = cartQty();
    const local = $('#cartN');
    if (local && local.textContent !== String(count)) local.textContent = count;
    const themeCount = ensureThemeCounter();
    if (themeCount) {
      if (themeCount.textContent !== String(count)) themeCount.textContent = count;
      themeCount.hidden = count === 0;
      themeCount.style.display = count === 0 ? 'none' : '';
    }
  }

  // ---------------------------------------------------------------------------
  // RENDER: tutto ciò che dipende dal colore scelto
  // ---------------------------------------------------------------------------
  let lastI = -1;
  function render() {
    const s = S[st.i], g = WORN[s.w], changed = lastI !== st.i;
    st.q = Math.min(st.q, Math.max(1, s.maxQ));
    if (s.available) delete phone.dataset.bpEsaurito; else phone.dataset.bpEsaurito = 'si';
    $$('.js-add').forEach((button) => { button.disabled = !s.available || busy; });
    if (!s.available) $$('.js-ctat').forEach((label) => { label.textContent = 'Esaurito'; });
    else if (lastI > -1 && !S[lastI].available) $$('.js-ctat').forEach((label) => { label.textContent = 'Aggiungi al carrello'; });
    $$('.js-sub').forEach((label) => { label.hidden = !s.available; });
    $$('#buyrow [data-bp="quantita"] button').forEach((button) => { if (!s.available) button.disabled = true; });
    if (s.available) $('#buyNow').removeAttribute('aria-disabled');
    else $('#buyNow').setAttribute('aria-disabled', 'true');
    $('#buyNow').style.pointerEvents = s.available ? '' : 'none';
    $('#buyNow').hidden = !s.available;
    const availability = $('[data-bp="fatti"] li:first-child span:last-child');
    if (availability) availability.innerHTML = s.available ? D.fatti[0] : 'Al momento esaurito';
    const availabilityDot = $('[data-bp="fatti"] li:first-child .dot');
    if (availabilityDot) availabilityDot.classList.toggle('unavailable', !s.available);
    phone.style.setProperty('--bp-s', s.hex);
    phone.style.setProperty('--bp-sd', darker(s.hex, 0.3));
    $$('.js-code').forEach((e) => { e.textContent = s.c; });
    $$('.js-tone').forEach((e) => { e.textContent = s.tone; });
    $$('.js-mood').forEach((e) => { e.textContent = s.mood; });
    $$('.js-shr').forEach((e) => { e.textContent = s.rv ? '★ ' + dec(s.rv[0]) + ' · ' + s.rv[1] + ' ' + recensionLabel(s.rv[1]) : D.recensioni?.per_variante === false ? '' : 'Ancora senza recensioni'; });
    $$('.js-dockt').forEach((e) => { e.textContent = single ? D.prodotto.nome_breve : s.c + ' · ' + s.tone; });
    $$('.js-bead').forEach((e) => { e.style.setProperty('--c', s.hex); });
    const tot = s.price * st.q;
    const priceEl = $('[data-bp="prezzo"]');
    priceEl.innerHTML = '<small>€</small>' + s.price.toFixed(2).replace('.', ',');
    priceEl.setAttribute('aria-label', 'Prezzo ' + s.price.toFixed(2).replace('.', ',') + ' euro');
    $$('.js-sub').forEach((e) => { e.textContent = (st.q > 1 ? st.q + ' × ' : '') + (single ? D.prodotto.nome_breve : s.c + ' ' + s.tone) + ' · ' + eur(tot); });
    $$('#beads .bd').forEach((b, k) => { b.setAttribute('aria-checked', String(k === st.i)); b.tabIndex = k === st.i ? 0 : -1; });
    $$('#rail button').forEach((b, k) => b.setAttribute('aria-pressed', String(k === st.i)));
    if (!single) $$('#grid8 .card').forEach((b, k) => b.setAttribute('aria-pressed', String(k === st.i)));
    if (changed) {
      const gp = $('#gPack');
      gp.src = u(s.img, 800);
      gp.srcset = srcset(s.img, [500, 800, 1200]);
      gp.sizes = '(max-width: 440px) 88vw, 400px';
      const imageNote = D.presentazione_packshot?.per_variante?.[s.c]?.etichetta_immagine || '';
      gp.alt = D.prodotto.nome_alt + (single ? '' : ' ' + s.c + ' ' + s.tone) + ' – Beauty Price Cosmetics' + (imageNote ? ' · ' + imageNote : '');
      if (D.presentazione_packshot?.per_variante) {
        $('.slide[data-bp-slide="foto"] figcaption').textContent = imageNote || D.galleria[0].chip;
        // Il solo swatch illustrativo resta intero sotto la didascalia alta.
        const illustrative = D.presentazione_packshot.per_variante[s.c].tipo === 'illustrativo';
        gp.style.paddingTop = illustrative ? '48px' : '';
        gp.style.boxSizing = illustrative ? 'border-box' : '';
      }
      gp.classList.toggle('bgfix', !!s.bg);
      $$('.js-pack').forEach((e) => { e.src = u(s.img, 600); e.classList.toggle('bgfix', !!s.bg); });
      syncPackPresentation(s.c);
      if (lastI > -1 && !reduce) { gp.classList.remove('swap'); void gp.offsetWidth; gp.classList.add('swap'); }
      // Simulazione opzionale: coordinate e etichette provengono dai dati.
      if (g && $('#gWorn')) {
      const wf = u(g.f, 1000);
      if ($('#gWorn').getAttribute('src') !== wf) $('#gWorn').src = wf;
      const rows = D.varianti.filter((item) => (item.simulazione?.griglia ?? 0) === s.w).map((item) => item.codice);
      $('#gWorn').alt = g.cells
        ? 'Simulazione illustrativa del colore ' + s.c + ' ' + s.tone + ' su ' + cellCount(g, s.row) + ' incarnati'
        : 'Simulazione illustrativa dei colori ' + rows.join('–') + ' su ' + cellCount(g, s.row) + ' incarnati; evidenziato il ' + s.c;
      $('#gWbox').style.aspectRatio = g.W + ' / ' + g.H;
      const hl = $('#gHl');
      // Nel nuovo formato l'intera foto è della variante: il riquadro non evidenzierebbe un'altra riga.
      hl.hidden = !!g.cells;
      if (!g.cells) {
        hl.style.left = (g.cols[0][0] / g.W) * 100 + '%';
        hl.style.right = ((g.W - g.cols[g.cols.length - 1][1]) / g.W) * 100 + '%';
        hl.style.top = (g.rows[s.row][0] / g.H) * 100 + '%';
        hl.style.height = ((g.rows[s.row][1] - g.rows[s.row][0]) / g.H) * 100 + '%';
      }
      $$('#olg .wt').forEach((b) => {
        const im = b.querySelector('img');
        if (im.getAttribute('src') !== wf) im.src = wf;
        im.alt = '';
        cropCell(b, g, s.row, +b.dataset.col);
      });
      const wi = $('#wtile img');
      if (wi && wi.getAttribute('src') !== wf) wi.src = wf;
      if ($('#wtile')) cropCell($('#wtile'), g, s.row, Math.min(1, cellCount(g, s.row) - 1));
      $$('[data-story-sim="1"]').forEach((img) => {
        img.src = wf;
        const box = img.closest('[data-story-col]');
        if (box) cropCell(box, g, s.row, Math.min(Number(box.dataset.storyCol), cellCount(g, s.row) - 1));
      });
      }
      try { history.replaceState(null, '', location.pathname + '?variant=' + s.vid + location.hash); } catch (e) { /* file:// in alcuni browser */ }
    }
    lastI = st.i;
    $('#qOut').textContent = st.q;
    $('#qMinus').disabled = !s.available || st.q <= 1;
    $('#qPlus').disabled = !s.available || st.q >= s.maxQ;
    $('#buyNow').href = cartURL(s.vid + ':' + st.q);
    const n = cartQty();
    updateCartCount();
    const cartButton = document.querySelector('[data-bp="carrello-icona"]') || $('#cartBtn');
    cartButton?.setAttribute('aria-label', 'Carrello: ' + n + (n === 1 ? ' articolo' : ' articoli'));
    if (!s.available) setDock();
    if (!sheet.hidden) renderSheet();
  }

  function setShade(i, opts) {
    if (i === st.i) return;
    st.i = i; buzz(8); render();
    if (opts && opts.toast) toast(S[i].c + ' · ' + S[i].tone);
  }

  // ---------------------------------------------------------------------------
  // FOGLIO CARRELLO: barra verso la spedizione gratuita, un altro colore, il gloss
  // ---------------------------------------------------------------------------
  function setCheckoutLink(empty) {
    const co = $('#shCheckout');
    if (empty) {
      co.removeAttribute('href');
      co.setAttribute('aria-disabled', 'true');
      co.tabIndex = -1;
    } else {
      co.href = routeRoot.replace(/\/$/, '') + '/checkout';
      co.removeAttribute('aria-disabled');
      co.removeAttribute('tabindex');
    }
    co.style.opacity = empty ? '.5' : '';
    co.style.pointerEvents = empty ? 'none' : '';
  }

  function renderSheet() {
    const tot = cartTot(), general = generalTotal(), left = general === 0 ? 0 : Math.max(0, 49 - general);
    $('#shList').innerHTML = st.lines.map((l) =>
      '<li' + (st.fresh.includes(l.vid) ? ' class="fade"' : '') + '><span class="th"><img src="' + esc(l.img) + '" alt=""' + (l.bg ? ' class="bgfix"' : '') + ' width="104" height="104"></span>' +
      '<span class="tx"><span class="t1">' + esc(l.title) + '</span><span class="t2">' + esc(l.sub) + '</span><span class="t3 num">' + eur(l.total) + '</span></span>' +
      '<span class="lgs mq" role="group" aria-label="Quantità ' + esc(l.title + ' ' + l.sub) + '"><button data-key="' + esc(l.key) + '" data-d="-1" aria-label="Togli un pezzo">' +
      (l.qty === 1 ? '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12"/></svg>' : '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 12h12"/></svg>') +
      '</button><output class="num">' + l.qty + '</output><button data-key="' + esc(l.key) + '" data-d="1" aria-label="Aggiungi un pezzo"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 12h12M12 6v12"/></svg></button></span></li>').join('');
    st.fresh = [];
    const empty = st.lines.length === 0;
    $('#shShip').classList.toggle('free', left === 0 && !empty);
    const pezzi = Math.ceil(left / S[st.i].price - 1e-9);
    const key = (pezzi === 1 ? 'uno_' : 'molti_') + (D.prodotto.genere === 'f' ? 'femminile' : 'maschile');
    const missing = D.carrello.spedizione_mancante[key]
      .replace('{mancano}', eur(left)).replace('{pezzi}', String(pezzi))
      .replace('{nome_singolare}', esc(D.prodotto.nome_singolare)).replace('{nome_plurale}', esc(D.prodotto.nome_plurale));
    $('#shShipTxt').innerHTML = empty ? 'Il carrello è vuoto' : left === 0 ? '<b>Spedizione Express gratuita</b> ✓' : missing;
    const w = empty ? '0%' : Math.min(100, (general / 49) * 100) + '%';
    requestAnimationFrame(() => requestAnimationFrame(() => { $('#shMeter').style.width = w; }));
    if ($('#shGloss')) $('#shGloss').hidden = !G.length || st.lines.some((l) => G.some((g) => String(g.vid) === l.vid));
    $$('#glPills button').forEach((b, k) => { b.setAttribute('aria-checked', String(k === st.g)); b.tabIndex = k === st.g ? 0 : -1; });
    if (G.length) {
      if ($('#glImg')) $('#glImg').src = u(G[st.g].img, 160);
      if ($('#glAdd')) $('#glAdd').textContent = 'Aggiungi ' + G[st.g].c;
    }
    $('#shSub').textContent = eur(tot);
    $('#shShipCost').textContent = empty ? '—' : left === 0 ? 'Gratuita' : eur(SHIP);
    $('#shTot').textContent = eur(empty ? 0 : tot + (left === 0 ? 0 : SHIP));
    setCheckoutLink(empty);
  }

  // ---------------------------------------------------------------------------
  // AVVISI e PANNELLI (il tasto "indietro" del telefono li chiude)
  // ---------------------------------------------------------------------------
  const toast = (msg, duration = 2200) => {
    toastEl.textContent = msg; toastEl.hidden = false;
    clearTimeout(toast.t); toast.t = later(() => { toastEl.hidden = true; }, duration);
  };
  const popCart = () => { const c = document.querySelector('[data-bp="carrello-contatore"]') || $('#cartN'); if (!c) return; c.classList.remove('pop'); void c.offsetWidth; c.classList.add('pop'); };
  let ov = null, ovPushed = false, lastFocus = null;
  const previousInert = new Map();
  let previousOverflow = null;
  const setModal = (on) => {
    const targets = [...document.body.children].filter((child) => !panels.includes(child));
    targets.forEach((c) => {
      if (on) { if (!previousInert.has(c)) previousInert.set(c, c.inert); c.inert = true; }
      else if (previousInert.has(c)) { c.inert = previousInert.get(c); previousInert.delete(c); }
    });
    if (on && previousOverflow === null) previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = on ? 'hidden' : (previousOverflow ?? '');
    if (!on) previousOverflow = null;
  };
  function ovOpen(el, focusEl) {
    lastFocus = document.activeElement;
    ov = el; el.hidden = false; setModal(true); setDock();
    try { history.pushState({ bpOv: 1 }, ''); ovPushed = true; } catch (e) { ovPushed = false; }
    requestAnimationFrame(() => { if (!disposed) (focusEl || el).focus({ preventScroll: true }); });
  }
  function ovHide() {
    if (!ov) return;
    ov.hidden = true;
    if (ov === lb) { lb.classList.remove('zoomed'); $$('.lbs', lb).forEach((s) => s.classList.remove('zoom')); }
    ov = null; setModal(false); setDock();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function ovClose() {
    if (!ov) return;
    if (ovPushed) { ovPushed = false; history.back(); } else ovHide();
  }
  function closeSheetForLaunch() {
    if (ov !== sheet) return;
    ovHide();
    if (ovPushed && history.state?.bpOv) {
      ovPushed = false;
      const state = { ...history.state }; delete state.bpOv;
      try { history.replaceState(state, '', location.href); } catch (e) { /* history unavailable */ }
    }
  }
  async function openCampaignNative(opener) {
    if (!window.BPLaunchCart?.campaignActive()) return false;
    closeSheetForLaunch();
    return window.BPLaunchCart.openNative(opener);
  }
  onWindow('popstate', () => { if (ov) { ovPushed = false; ovHide(); } });
  document.addEventListener('keydown', (e) => {
    if (!ov) return;
    if (e.key === 'Escape') { e.preventDefault(); ovClose(); return; }
    if (e.key === 'Tab') { // trappola del fuoco dentro il pannello aperto
      const f = $$('button:not([disabled]):not([tabindex="-1"]), a[href], [tabindex="0"]', ov).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  }, { signal: controller.signal });

  function openSheet(added) {
    $('#shTitle').innerHTML = added ? '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#DA001D"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>Aggiunto al carrello' : 'Il tuo carrello';
    renderSheet();
    $('.sheet', sheet).scrollTop = 0;
    ovOpen(sheet, $('.sheet [data-close].x', sheet));
  }
  $$('[data-close]').forEach((b) => listen(b, 'click', () => ovClose()));

  // ---------------------------------------------------------------------------
  // AGGIUNTA AL CARRELLO: perla del colore che vola nel carrello, spunta che si disegna
  // ---------------------------------------------------------------------------
  const flying = new Set();
  function fly(from, hex, done) {
    const cart = document.querySelector('[data-bp="carrello-icona"]') || $('#cartBtn');
    if (reduce || !from || !cart || !from.animate) { done(); return; }
    const a = from.getBoundingClientRect(), b = cart.getBoundingClientRect();
    const el = document.createElement('span');
    el.className = 'bp-pannello bead fly'; el.style.setProperty('--c', hex); el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);
    const x0 = a.left + a.width / 2 - 17, y0 = a.top + a.height / 2 - 17, x1 = b.left + b.width / 2 - 17, y1 = b.top + b.height / 2 - 17;
    const mx = x0 + (x1 - x0) * 0.42, my = Math.min(y0, y1) - Math.min(160, Math.abs(y0 - y1) * 0.35 + 60);
    const an = el.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(.5)', opacity: 0 },
      { transform: 'translate(' + x0 + 'px,' + (y0 - 26) + 'px) scale(1.15)', opacity: 1, offset: 0.14 },
      { transform: 'translate(' + mx + 'px,' + my + 'px) scale(1)', opacity: 1, offset: 0.56 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.38)', opacity: 0.9 }
    ], { duration: 640, easing: 'cubic-bezier(.45,0,.25,1)' });
    flying.add({ element: el, animation: an });
    an.onfinish = () => { el.remove(); for (const flight of flying) if (flight.element === el) flying.delete(flight); if (!disposed) done(); };
  }
  let ctaT = 0;
  async function doAdd(e) {
    const btn = e.currentTarget, s = S[st.i], q = st.q;
    if (!s.available || busy) return;
    if (!await addItems([{ ...lipLine(st.i), qty: q }]) || disposed) return;
    buzz(14);
    $$('.js-add').forEach((b) => b.classList.add('done'));
    $$('.js-ctat').forEach((x) => { x.textContent = q > 1 ? 'Aggiunti ' + q : 'Aggiunto'; });
    clearTimeout(ctaT);
    ctaT = later(() => {
      $$('.js-add').forEach((b) => b.classList.remove('done'));
      $$('.js-ctat').forEach((x) => { x.textContent = 'Aggiungi al carrello'; });
    }, 2200);
    st.q = 1;
    fly(btn, s.hex, () => { render(); popCart(); });
    if (window.BPLaunchCart?.campaignActive()) {
      try { await openCampaignNative(btn); } catch (error) { reportCartError(error); }
    } else later(() => openSheet(true), reduce ? 0 : 560);
  }
  $$('.js-add').forEach((b) => listen(b, 'click', doAdd));
  listen($('#buyNow'), 'click', () => buzz(10));

  listen($('#shList'), 'click', async (e) => {
    const b = e.target.closest('button[data-key]'); if (!b || busy) return;
    const l = st.lines.find((x) => x.key === b.dataset.key); if (!l) return;
    const quantity = Math.max(0, l.qty + Number(b.dataset.d));
    setBusy(true);
    try {
      await cartRequest('change.js', { id: l.key, quantity });
      await refreshCart();
      buzz(8);
      if (quantity === 0) toast('Tolto dal carrello');
      const again = $$('#shList button[data-key]').find((button) => button.dataset.key === l.key && button.dataset.d === b.dataset.d);
      (again || $('.sheet [data-close].x', sheet)).focus({ preventScroll: true });
    } catch (error) { reportCartError(error); }
    finally { if (!disposed) setBusy(false); }
  });
  listen($('#shCheckout'), 'click', async (e) => {
    if (!window.BPLaunchCart || !(window.BPLaunch?.state?.().active || window.BPLaunch?.state?.().ended)) return;
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const actual = await window.BPLaunchCart.sync();
      if (window.BPLaunch?.state?.().ended && actual?.items?.some(window.BPLaunchCart.isGift)) throw new Error('L’organizer deve essere rimosso prima del pagamento.');
      location.assign(routeRoot.replace(/\/$/, '') + '/checkout');
    } catch (error) { reportCartError(error); }
    finally { if (!disposed) setBusy(false); }
  });
  listen($('#shMini'), 'click', async (e) => {
    const b = e.target.closest('button'); if (!b) return;
    if (single) {
      const k = Number(b.dataset.k);
      if (!COMPLETE[k]) return;
      if (!await addItems([{ ...completeLine(k), qty: 1 }])) return;
      buzz(10); render(); popCart();
      toast(COMPLETE[k].nome_breve + ' aggiunto'); return;
    }
    const i = +b.dataset.i;
    if (!S[i].available) { toast(S[i].c + ' esaurito'); return; }
    if (!await addItems([{ ...lipLine(i), qty: 1 }])) return;
    buzz(10); render(); popCart();
    toast(S[i].c + ' ' + S[i].tone + ' aggiunto');
  });
  if ($('#glPills')) listen($('#glPills'), 'click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    st.g = +b.dataset.k; buzz(6); renderSheet();
  });
  if ($('#glPills')) listen($('#glPills'), 'keydown', (e) => {
    if (!G.length) return;
    const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!d) return;
    e.preventDefault();
    st.g = (st.g + d + G.length) % G.length; renderSheet();
    $$('#glPills button')[st.g].focus();
  });
  if ($('#glAdd')) listen($('#glAdd'), 'click', async () => {
    if (!G[st.g]) return;
    if (!await addItems([{ ...glossLine(st.g), qty: 1 }])) return;
    buzz(10); render(); popCart();
    toast(pairingControlLabel ? D.carrello.abbinamento.titolo + ' aggiunto' :
      (D.prodotto.handle === 'rossetto-liquido-matte-plump' ? 'Gloss' : D.carrello.abbinamento.titolo) + ' ' + G[st.g].c + ' aggiunto');
    $('#shCheckout').focus({ preventScroll: true });
  });
  const themeCartSelector = '#cart-icon-bubble, a[href*="/cart"].header__icon, .header__icon--cart, [data-header-cart]';
  const themeCounterSelector = '.wt-header__panel__counter, .cart-count-bubble, [data-cart-count], .cart-count';
  let themeCart = null;
  let themeCounter = null;
  let themeCounterState = null;
  let themeCartObserver = null;
  function releaseThemeCounter() {
    if (!themeCounter) return;
    if (themeCounterState?.created) themeCounter.remove();
    else {
      themeCounter.hidden = themeCounterState.hidden;
      themeCounter.style.display = themeCounterState.display;
      themeCounter.removeAttribute('data-bp');
    }
    themeCounter = null;
    themeCounterState = null;
  }
  function ensureThemeCounter() {
    const liveCart = document.querySelector(themeCartSelector);
    if (liveCart !== themeCart) {
      themeCartObserver?.disconnect();
      themeCartObserver = null;
      releaseThemeCounter();
      themeCart?.removeAttribute('data-bp');
      themeCart = liveCart;
      if (themeCart) {
        themeCart.setAttribute('data-bp', 'carrello-icona');
        themeCartObserver = new MutationObserver(() => { if (!disposed) updateCartCount(); });
        themeCartObserver.observe(themeCart, { childList: true, subtree: true });
      }
    }
    if (!themeCart) return null;
    const liveCounter = themeCart.querySelector(themeCounterSelector);
    if (!themeCounter || liveCounter !== themeCounter) {
      releaseThemeCounter();
      themeCounter = liveCounter || document.createElement('span');
      const created = !liveCounter;
      themeCounterState = { created, hidden: themeCounter.hidden, display: themeCounter.style.display };
      if (created) {
        themeCounter.className = 'wt-header__panel__counter';
        themeCounter.setAttribute('data-bp-created', 'carrello-contatore');
        themeCart.appendChild(themeCounter);
      }
      themeCounter.setAttribute('data-bp', 'carrello-contatore');
    }
    return themeCounter;
  }
  ensureThemeCounter();
  listen(document, 'shopify:section:load', () => updateCartCount());
  listen(document, 'bp:launch:cart', (event) => {
    if (!disposed && event.detail?.cart) syncCart(event.detail.cart);
  });
  const cartClick = async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    try {
      if (await openCampaignNative(e.target.closest('a,button') || e.target)) return;
      await refreshCart(); if (cartQty()) openSheet(false); else toast('Il carrello è vuoto');
    }
    catch (error) { reportCartError(error); }
  };
  listen(document, 'click', (event) => {
    if (event.target.closest?.(themeCartSelector)) cartClick(event);
  }, { capture: true });
  listen($('#cartBtn'), 'click', cartClick);
  listen(document, 'bp:launch:tick', () => {
    if (ov === sheet && window.BPLaunchCart?.campaignActive()) openCampaignNative(document.activeElement).catch(reportCartError);
  });

  // ---------------------------------------------------------------------------
  // SCELTA DEL COLORE: perle (radiogroup con frecce), barra sulla foto, schede degli 8 colori
  // ---------------------------------------------------------------------------
  if ($('#beads')) listen($('#beads'), 'click', (e) => { const b = e.target.closest('.bd'); if (b) setShade(+b.dataset.i); });
  if ($('#beads')) listen($('#beads'), 'keydown', (e) => {
    const map = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (e.key in map) {
      e.preventDefault();
      setShade((st.i + map[e.key] + S.length) % S.length);
      $$('#beads .bd')[st.i].focus();
    } else if (e.key === 'Home' || e.key === 'End') {
      e.preventDefault(); setShade(e.key === 'Home' ? 0 : S.length - 1); $$('#beads .bd')[st.i].focus();
    }
  });
  if ($('#rail')) listen($('#rail'), 'click', (e) => { const b = e.target.closest('button'); if (b) setShade(+b.dataset.i); });
  if (!single) listen($('#grid8'), 'click', (e) => {
    const b = e.target.closest('.card'); if (!b) return;
    const i = +b.dataset.i;
    if (i === st.i) toast(S[i].c + ' è già il tuo colore'); else setShade(i, { toast: true });
  });
  listen($('#qMinus'), 'click', () => { st.q = Math.max(1, st.q - 1); buzz(6); render(); });
  listen($('#qPlus'), 'click', () => { st.q = Math.min(S[st.i].maxQ, st.q + 1); buzz(6); render(); });

  // ---------------------------------------------------------------------------
  // GALLERIA: pallini, contatore, foto a schermo intero con zoom
  // ---------------------------------------------------------------------------
  const slides = $$('.slide', gal), dots = $$('#dots span');
  let gRaf = 0;
  listen(gal, 'scroll', () => {
    cancelAnimationFrame(gRaf);
    gRaf = requestAnimationFrame(() => {
      const step = slides[0].offsetWidth + 10;
      const k = clamp(Math.round(gal.scrollLeft / step), 0, slides.length - 1);
      if (k === st.gIdx) return;
      st.gIdx = k;
      dots.forEach((d, j) => d.classList.toggle('on', j === k));
      $('#gNum').textContent = k + 1;
      $('#gZoom').setAttribute('aria-label', 'Apri le foto a schermo intero, ' + (k + 1) + ' / ' + slides.length);
      gal.parentElement.classList.toggle('on-info', slides[k]?.dataset.bpSlide?.startsWith('info-') || false);
    });
  }, { passive: true });
  const lbTrack = $('#lbTrack');
  const photos = D.galleria.filter((item) => ['foto', 'simulazione', 'foto-extra'].includes(item.tipo))
    .concat((D.da_vicino || []).map((item) => ({ ...item, tipo: 'foto-extra' })));
  function photoInfo(item) {
    const s = S[st.i];
    if (item.tipo === 'foto') {
      const note = D.presentazione_packshot?.per_variante?.[s.c]?.etichetta_immagine;
      return { src: u(s.img, 1400), alt: $('#gPack').alt,
        label: (single ? D.prodotto.nome_breve : s.c + ' ' + s.tone) + (note ? ' · ' + note : '') };
    }
    if (item.tipo === 'simulazione') {
      const g = WORN[s.w];
      return { src: u(g.f, 1400), alt: $('#gWorn')?.alt || 'Simulazione illustrativa', label: single ? 'Simulazione illustrativa' : (g.cells || g.nativeRatio) ? 'Simulazione illustrativa · colore selezionato ' + s.c : 'Simulazione illustrativa · ' + s.c + ' evidenziato' };
    }
    return { src: u(item.file, 1400), alt: item.alt || '', label: item.chip || item.alt || 'Dettaglio' };
  }
  function lbLabel() {
    $('#lbN').innerHTML = (st.lbIdx + 1) + ' / ' + photos.length + '<small>' + esc(photoInfo(photos[st.lbIdx]).label) + '</small>';
  }
  function openLb(k) {
    lbTrack.innerHTML = photos.map((item, i) => {
      const photo = photoInfo(item);
      return '<div class="lbs"><img id="lb' + i + '" src="' + esc(photo.src) + '" alt="' + esc(photo.alt) + '"></div>';
    }).join('');
    st.lbIdx = k; ovOpen(lb, $('[data-lbclose]', lb));
    requestAnimationFrame(() => { lbTrack.scrollLeft = k * lbTrack.clientWidth; lbLabel(); });
  }
  $$('.slide.zoomable', gal).forEach((f) => listen(f, 'click', () => openLb(+f.dataset.lb)));
  listen($('#gZoom'), 'click', () => openLb(Number(slides[st.gIdx]?.dataset.lb || 0)));
  $$('#olg .wt').forEach((b) => listen(b, 'click', () => openLb(photos.findIndex((item) => item.tipo === 'simulazione'))));
  $$('.near-photo').forEach((b, index) => listen(b, 'click', () => openLb(D.galleria.filter((item) => ['foto', 'simulazione', 'foto-extra'].includes(item.tipo)).length + index)));
  listen(lbTrack, 'scroll', () => {
    const k = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
    if (k !== st.lbIdx && !lb.classList.contains('zoomed')) { st.lbIdx = k; lbLabel(); }
  }, { passive: true });
  listen(lbTrack, 'click', (e) => {
    const sl = e.target.closest('.lbs'); if (!sl) return;
    if (e.target.tagName !== 'IMG') { ovClose(); return; }
    const z = !sl.classList.contains('zoom');
    sl.classList.toggle('zoom', z); lb.classList.toggle('zoomed', z);
    if (z) requestAnimationFrame(() => {
      const r = e.target.getBoundingClientRect();
      sl.scrollLeft = Math.max(0, (r.width - sl.clientWidth) / 2);
      sl.scrollTop = Math.max(0, (r.height - sl.clientHeight) / 2);
    });
  });
  listen($('[data-lbclose]', lb), 'click', () => ovClose());

  // Condividi il colore scelto
  listen($('#share'), 'click', async () => {
    const s = S[st.i], url = D.prodotto.url + '?variant=' + s.vid;
    const data = { title: D.identita.condividi.titolo.replace('{codice}', s.c),
      text: D.identita.condividi.testo.replace('{codice}', s.c).replace('{tono}', s.tone), url };
    try {
      if (navigator.share) { await navigator.share(data); return; }
      await navigator.clipboard.writeText(url); toast('Link copiato');
    } catch (e) { if (e && e.name !== 'AbortError') toast('Link: ' + url.replace('https://', '')); }
  });

  // ---------------------------------------------------------------------------
  // BARRA FISSA: compare quando il pulsante principale è passato, sparisce alla chiusura
  // ---------------------------------------------------------------------------
  let mainGone = false, endIn = false;
  function setDock() {
    const on = mainGone && !endIn && !ov && S[st.i].available;
    dock.classList.toggle('on', on);
    dock.setAttribute('aria-hidden', String(!on));
    $('#addDock').tabIndex = on ? 0 : -1;
  }
  // Controllo a ogni scorrimento (anche dopo un salto con un link interno, che un IntersectionObserver non segnala)
  const buyrow = $('#buyrow'), endSec = $('#end');
  let dRaf = 0;
  function dockCheck() {
    dRaf = 0;
    const br = buyrow.getBoundingClientRect(), er = endSec.getBoundingClientRect();
    const g = br.bottom < 0, e = er.top < innerHeight - 40 && er.bottom > 0;
    if (g !== mainGone || e !== endIn) { mainGone = g; endIn = e; setDock(); }
  }
  onWindow('scroll', () => { if (!dRaf) dRaf = requestAnimationFrame(dockCheck); }, { passive: true });
  onWindow('resize', () => { if (!dRaf) dRaf = requestAnimationFrame(dockCheck); });

  // ---------------------------------------------------------------------------
  // SCROLLYTELLING SOBRIO: 4 capitoli, solo dissolvenze e piccoli segni
  // ---------------------------------------------------------------------------
  const story = $('#story'), chs = $$('.c', story), vis = $$('.v', story), prog = $$('#stProg i');
  const genericStory = story.dataset.bpStory === 'generic';
  const wat = $('#wat'), capN = $('#capN'), dGl = $('#dGl'), dl1 = $('#dl1'), dl2 = $('#dl2'), sweep = $('#sweep'), okc = $('#okc');
  let lastK = -1, sRaf = 0;
  function storyFrame() {
    sRaf = 0;
    const r = story.getBoundingClientRect(), vh = innerHeight, total = Math.max(1, r.height - vh);
    if (r.bottom < -50 || r.top > vh + 50) return;
    const p = clamp(-r.top / total, 0, 1), N = chs.length, f = p * N, k = Math.min(N - 1, Math.floor(f)), t = k === N - 1 ? clamp((f - k) * 1.25, 0, 1) : clamp(f - k, 0, 1);
    if (k !== lastK) {
      chs.forEach((c, j) => c.classList.toggle('on', j === k));
      vis.forEach((x, j) => x.classList.toggle('on', j === k));
      lastK = k;
    }
    prog.forEach((el, j) => el.style.setProperty('--f', j < k ? 1 : j === k ? t.toFixed(3) : 0));
    if (genericStory) {
      const mark = vis[k], kind = mark?.dataset.storyKind, value = ease(t);
      if (mark) {
        mark.style.setProperty('--story-progress', value.toFixed(3));
        if (kind === 'capsula') {
          const fill = mark.querySelector('.wat'), num = mark.querySelector('.capnum b');
          const max = Number(num.dataset.value);
          fill.style.height = 'calc((100% - 10px) * ' + (value * Number(fill.dataset.fill)).toFixed(4) + ')';
          num.textContent = Math.round(max * value) + (D.storia.capitoli[k].segno.unita || '%');
        } else if (kind === 'disco') {
          mark.querySelector('.gl').style.opacity = D.storia.capitoli[k].segno.verso === 'luminoso' ? value.toFixed(3) : (1 - value).toFixed(3);
          mark.querySelectorAll('.disc-l span').forEach((label, j) => label.classList.toggle('on', j === (value > .5 ? 2 : 0)));
        } else if (kind === 'spunta') {
          mark.querySelector('.ok').style.setProperty('--d', (60 * (1 - value)).toFixed(1));
        } else if (kind === 'tessera' || kind === 'lente') {
          mark.querySelector('.sweep').style.setProperty('--x', (140 - 180 * value).toFixed(1) + '%');
        }
      }
      return;
    }
    const wv = k === 0 ? ease(clamp(t * 1.6, 0, 1)) : 1;
    const waterPercent = Number(D.storia.capitoli[0].segno.valore);
    wat.style.height = 'calc((100% - 10px) * ' + (wv * waterPercent / 100).toFixed(4) + ')';
    capN.textContent = Math.round(wv * waterPercent) + '%';
    const gv = k < 1 ? 1 : k === 1 ? 1 - ease(clamp(t * 1.5, 0, 1)) : 0;
    dGl.style.opacity = gv.toFixed(3);
    dl1.classList.toggle('on', gv > 0.5); dl2.classList.toggle('on', gv <= 0.5);
    sweep.style.setProperty('--x', (140 - 180 * (k === 2 ? ease(t) : k > 2 ? 1 : 0)).toFixed(1) + '%');
    if (okc) okc.style.setProperty('--d', (k === 3 ? 60 * (1 - ease(clamp(t * 1.7, 0, 1))) : k > 3 ? 0 : 60).toFixed(1));
  }
  if (!reduce) {
    onWindow('scroll', () => { if (!sRaf) sRaf = requestAnimationFrame(storyFrame); }, { passive: true });
    onWindow('resize', () => { if (!sRaf) sRaf = requestAnimationFrame(storyFrame); });
  } else {
    // versione statica: valori finali
    vis.forEach((x, j) => x.classList.toggle('on', j < chs.length));
    chs.forEach((c) => c.classList.add('on'));
  }

  setCheckoutLink(true);
  render();
  storyFrame();
  dockCheck();
  refreshCart().catch(reportCartError);
  instances.set(phone, () => {
    disposed = true;
    controller.abort();
    observers.forEach((observer) => observer.disconnect());
    [headerRaf, gRaf, dRaf, sRaf].forEach(cancelAnimationFrame);
    timers.forEach(clearTimeout); timers.clear();
    flying.forEach(({ element, animation }) => { animation.cancel(); element.remove(); }); flying.clear();
    if (ov) ovHide();
    panels.forEach((panel) => { panel.hidden = true; panel.classList.remove('bp-pannello'); panel.removeAttribute('data-bp-panel-owner'); phone.appendChild(panel); });
    if (looxPlaceholder?.parentNode) { looxPlaceholder.parentNode.insertBefore(looxHost, looxPlaceholder); looxPlaceholder.remove(); }
    themeCartObserver?.disconnect();
    releaseThemeCounter();
    themeCart?.removeAttribute('data-bp');
    root.classList.remove('bp-text-zoom');
  });
  }
  function scan(context = document) { context.querySelectorAll('[data-bp-pdp]').forEach(init); if (context.matches?.('[data-bp-pdp]')) init(context); }
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const roots = event.target.matches?.('[data-bp-pdp]') ? [event.target] : [...event.target.querySelectorAll('[data-bp-pdp]')];
    roots.forEach((root) => { instances.get(root)?.(); instances.delete(root); });
  });
})();
